//sevices/utils/enums
import { isNullUndefinedEmpty } from "@/main/services/utils";

//types
import { DynamicReportPermissionResponse, DynamicReportResponse, DynamicReportVariableResponse } from "@/main/models/response";
import { DynamicReportForm, DynamicReportPermissionForm, DynamicReportVariableForm } from "./registerDynamicReport";
import { DynamicReportPermissionRequest, DynamicReportRequest, DynamicReportVariableRequest } from "@/main/models/request/dynamicReportRequest";

//map response to form data
export function mapDynamicReportResponseToFormData(data: DynamicReportResponse): DynamicReportForm {
  const mappedData: DynamicReportForm =  {
    guidDynamicReport: data.guidDynamicReport,
    country: { key: data.guidCountry, value: data.countryName },
    reportName: data.reportName,
    statusRegister:  { key: data.idStatusType, value: data.statusRegisterName },
    query: data.query,
    variables: data.variableResponse.map(mapDynamicReportVariableResponseToFormData),
    permissions: data.permissionResponse.map(mapDynamicReportPermissionResponseToFormData),
  };
  return mappedData;
}

export function mapDynamicReportVariableResponseToFormData(data: DynamicReportVariableResponse): DynamicReportVariableForm {
  const mappedData: DynamicReportVariableForm = {
    guidDynamicReportVariable: data.guidDynamicReportVariable,
    variableType: { key: data.idVariableType, value: data.variableTypeName },
    variableName: data.variableName,
    variableRangeName: data.variableRangeName,
    filterName: data.filterName,
    mandatory: data.isMandatory,
    ordering: data.ordering,
    maxAllowedRange: data.maxAllowedRange,
  }
  return mappedData;
}

export function mapDynamicReportPermissionResponseToFormData(data: DynamicReportPermissionResponse): DynamicReportPermissionForm {
  const mappedData: DynamicReportPermissionForm = {
    guidDynamicReportPermission: data.guidDynamicReportPermission,
    companyType: { key: data.idCompanyType, value: data.companyTypeName },
    company: !isNullUndefinedEmpty(data.guidCompany) ? { key: data.guidCompany, value: data.companyName } : null,
    allCompanies: isNullUndefinedEmpty(data.guidCompany)
  };
  return mappedData;
}



//map form data to request
export function mapDynamicReportFormDataToRequest(data: DynamicReportForm): DynamicReportRequest{
  const mappedData: DynamicReportRequest = {
    guidDynamicReport: data.guidDynamicReport,
    guidCountry: String(data.country?.key),
    reportName: data.reportName,
    idStatus: Number(data.statusRegister?.key),
    query: data.query,
    dynamicReportVariable: data.variables.map(mapDynamicReportVariableFormDataToRequest),
    permissions: data.permissions.map(mapDynamicReportPermissionFormDataToRequest)
  }
  return mappedData;
}

export function mapDynamicReportVariableFormDataToRequest(data: DynamicReportVariableForm): DynamicReportVariableRequest{
  const mappedData: DynamicReportVariableRequest = {
    guidDynamicReportVariable: data.guidDynamicReportVariable,
    idVariableType: Number(data.variableType?.key),
    variable: data.variableName,
    variableRange: data.variableRangeName,
    filterName: data.filterName,
    isMandatory: data.mandatory,
    maxAllowedRange: data.maxAllowedRange,
    ordering: data.ordering,
  }
  return mappedData;
}

export function mapDynamicReportPermissionFormDataToRequest(data: DynamicReportPermissionForm): DynamicReportPermissionRequest{
  const mappedData: DynamicReportPermissionRequest = {
    guidPermission: data.guidDynamicReportPermission,
    idCompanyType: Number(data.companyType?.key),
    guidCompany: !!data.company ? String(data.company.key) : null,
  }
  return mappedData;
}

